import React from 'react'
import Slider from 'react-slick'
import img1 from '../../Assets/Home/delivery.png'
import img2 from '../../Assets/Home/food.png'
import img3 from '../../Assets/Home/grocery.png'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const SliderImg = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 3000, 
    draggable: true, 
  }

  return (
    <div className='mt-8 mb-8'>
      <Slider {...settings} className='w-[100%] '>
        <div>
          <img src={img1} alt='Slider 1'  />
        </div>
        <div>
          <img src={img2} alt='Slider 2'  />
        </div>
        <div>
          <img src={img3} alt='Slider 3'  />
        </div>
      </Slider>
    </div>
  )
}

export default SliderImg
